<template>
  <action-menu-wrapper-v2 :items="activities">
    <template #trigger="{ showMenu }">
      <div class="flex items-center space-x-2" data-cy="activity-selector">
        <span>{{ title }}</span>
        <icon-base
          :icon="IconCaretDown"
          class="transform text-label"
          :class="{ 'rotate-180': showMenu }"
        />
      </div>
    </template>
  </action-menu-wrapper-v2>
</template>

<script setup lang="ts">
import { ref } from "vue";

import { CommunicationType } from "@/enums/communicationLogs";
import { communicationTitle } from "@/helpers/communication";

import IconCaretDown from "@/components/icons/deals/IconCaretDown.vue";
import ActionMenuWrapperV2 from "@/components/ui/ActionMenuWrapperV2.vue";
import IconBase from "@/components/ui/IconBase.vue";

import type { MenuItem } from "@/components/ui/ActionMenuWrapperV2.vue";

const { activeTypes, title } = defineProps<{
  activeTypes: CommunicationType[];
  title: string;
}>();

const emit = defineEmits<{ "activity-type:changed": [CommunicationType[]] }>();

const activities: MenuItem[] = [
  {
    label: communicationTitle[CommunicationType.note],
    handler: () => updateSelectedTypes(CommunicationType.note),
  },
  {
    label: communicationTitle[CommunicationType.sms],
    handler: () => updateSelectedTypes(CommunicationType.sms),
  },
  {
    label: communicationTitle[CommunicationType.call],
    handler: () => updateSelectedTypes(CommunicationType.call),
  },
  {
    label: communicationTitle[CommunicationType.task],
    handler: () => updateSelectedTypes(CommunicationType.task),
  },
  {
    label: communicationTitle[CommunicationType.email],
    handler: () => updateSelectedTypes(CommunicationType.email),
  },
];

const selectedTypes = ref<CommunicationType[]>(activeTypes);

const updateSelectedTypes = (type: CommunicationType) => {
  /**
   * For now we can only pass one type,
   * but this will be updated in the following PRs
   *
   *   if (selectedTypes.value.includes(type)) {
   *     selectedTypes.value = selectedTypes.value.filter((t) => t !== type);
   *   } else {
   *     selectedTypes.value.push(type);
   *   }
   */

  selectedTypes.value = [type];

  emit("activity-type:changed", selectedTypes.value);
};
</script>
